import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HeaderTab } from 'src/app/components/page-nav-bar/page-nav-bar.component';

@Injectable({ providedIn: 'root' })
export class PageNavigationService {
  private _secondaryTabs = new BehaviorSubject<HeaderTab[]>([]);
  readonly secondaryTabs$ = this._secondaryTabs.asObservable();

  setSecondaryTabs(tabs: HeaderTab[]): void {
    this._secondaryTabs.next(tabs);
  }

  clearSecondaryTabs(): void {
    this._secondaryTabs.next([]);
  }
}
